
const propertyStatusColor = {
	
	
	colors: {
		"Not contacted":		"#e5e9f1",
		"Contacted":			"#166ee2",
		"Unreachable":			"#616670",
		"Interested":			"#ffd76c",
		"Ready to sign":		"#9be095",
		"Signed":				"#068a0d",
		"Declined":				"#dc063c",
		"Competitor":			"#dd03a8",
		"default":				"#045a8d"
		
	},
	"asOptions" : function(status) {
		
		if(this.options)
			return this.options;
		
		this.options = this.getList().map((e)=>{ return {label:e, value:e}; });
		return this.options;
	},
	"asOption": function(value){
		if(!this.options)
			this.asOptions();
		
		return this.options.find((e) => e.value === value);
	},
	"asMapboxStyle": function (){
		return JSON.parse(JSON.stringify(this.colors).replaceAll(":", ",").replace("{","[").replace("}","]").replace('"default",',""));
	},
	"getColor": function(color){
		return this.colors[color] ? this.colors[color] : this.colors['default'];	
	},
	"getList" : function() {
		var statusList = Object.keys(this.colors);
		statusList.pop();
		return statusList;	
	}
};





export { propertyStatusColor };


